/**
 *
 * @param {*} data
 * data.url 视频资源地址
 * data.step 截取频率，默认0.15
 * data.captureCallBack 截图回调函数，返回当前截取截图数组
 * data.isCaptureCover 是否截取封面图， 默认false
 * data.clippingRatio 截取比例，默认0.1
 */
export default function captureVideo(data) {
  const tempFrame = []
  const isCaptureCover = data.isCaptureCover
  let hasCallBack = false
  const ratio = data.clippingRatio || 0.1

  let videoElement = document.createElement('video')
  videoElement.muted = true
  videoElement.crossOrigin = '*'
  videoElement.src = data.url
  const step = data.step || 0.15
  let canvas = document.createElement('canvas')
  let currentTime = 0
  let updateTime = 0

  const saveFrame = (frame) => {
    return {
      url: data.url,
      frame,
    }
  }

  const captureCallBack = () => {
    // 如果只是截取封面，只要回调一次即可
    if (isCaptureCover && hasCallBack) return
    hasCallBack = true
    data.captureCallBack(saveFrame(tempFrame))
  }

  videoElement.addEventListener('canplay', function () {
    if (!videoElement) return
    if (currentTime < videoElement.duration) {
      videoElement.currentTime = currentTime + step
      currentTime = currentTime + step
    }
  })

  videoElement.addEventListener('timeupdate', function () {
    if (!videoElement) return
    if (currentTime > 0) {
      canvas.width = videoElement.videoWidth * ratio
      canvas.height = videoElement.videoHeight * ratio
      canvas
        .getContext('2d')
        .drawImage(videoElement, 0, 0, canvas.width, canvas.height)
      const base64 = canvas.toDataURL('image/png')
      tempFrame.push({
        currentTime: currentTime * 1000,
        width: videoElement.videoWidth,
        height: videoElement.videoHeight,
        data: base64,
        duration: videoElement.duration,
      })
    }
    if (currentTime >= videoElement.duration) {
      captureCallBack()
      videoElement = null
      canvas = null
      // console.log('...完成截图...:', data.url)
    }
    if (currentTime - updateTime > 1) {
      if (isCaptureCover && !hasCallBack) {
        captureCallBack()
        updateTime = currentTime
      }
    }
  })
}
